import { IOfferListTableLang } from '../../../types/lang'

export const offerListTableLang: IOfferListTableLang = {
	offer_list_table: {
		column_id: 'ID_ru',
		column_name: 'Name_ru',
		column_affiliate_network: 'Affiliate Network_ru',
		column_country: 'Country_ru',
	}
}